import { Badge } from '@ntconsult/aluma-react';
import { Check, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/** Colunas sim/não ("Faturando", T18; "Avisado" do Pool, T3): `solid` para destacar; verde para sim, vermelho para não. */
export function YesNoBadge({ value }: { value: boolean }) {
  const { t } = useTranslation('common');

  return value ? (
    <Badge variant="solid" tone="success" shape="pill" size="sm" icon={<Check size={12} />}>
      {t('yes')}
    </Badge>
  ) : (
    <Badge variant="solid" tone="danger" shape="pill" size="sm" icon={<X size={12} />}>
      {t('no')}
    </Badge>
  );
}
